import './ClOfferListCount.css';

import React from 'react';

import classname from '@search/classname/src';
import { declensionByNumber } from '@search/helpers/src/declensionByNumber';
import { formatNumber } from '@search/helpers/src/formatNumber';

const cn = classname.bind(null, 'ClOfferListCount');

export function ClOfferListCount({ loading, count = 0 }: {
    loading?: boolean;
    count?: number;
}) {
    return (
        <div className={cn()}>
            {loading || count === undefined ?
                <>Ищем объявления</> :
                <>{formatNumber(count)} {declensionByNumber(count, [ 'объявление', 'объявления', 'объявлений' ])}</>
            }
        </div>
    );
}

